import _ from 'lodash';

const initForm = function () {
  return {
    addressId: 0,
  };
};

const state = initForm();

const mutations = {
  changeAddressId(state, value) {
    state.addressId = value;
  },
  clearData(state) {
    _.assign(state, initForm());
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
